import { render } from "./DatabaseNew.vue?vue&type=template&id=a1dc9254"
import script from "./DatabaseNew.vue?vue&type=script&lang=js"
export * from "./DatabaseNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__